import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { Suspense, useState } from 'react';

import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

import { useGetSessionQuery } from '@/api/apiSlice';
import { QuestionsList } from '@/layout/pages/Support/QuestionsList';
import { getSelectedAccount } from '@/redux/selectedAccountSlice';
import {
  Alert,
  Card,
  CardContent,
  CircularProgress,
  Skeleton,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import FaqServiceSectionWrapper from '@/features/faq/components/FaqServiceSectionWrapper';
import FaqQuestionSectionWrapper from '@/features/faq/components/FaqQuestionSectionWrapper';
import FaqQuestion from '@/features/faq/components/FaqQuestion';

const SupportPage = () => {
  const { data: session } = useGetSessionQuery();
  const { t } = useTranslation('support');
  const isAdmin = session?.claims?.['accounts.superuser'] === 'True' || false;
  const selectedAccount = useSelector(getSelectedAccount);
  const hasService = (service) =>
    selectedAccount?.Services?.some((s) => s.Name === service) || isAdmin;

  const [expanded, setExpanded] = React.useState(false);
  const [openQuestionSection, setOpenQuestionSection] = useState(null);

  const toggleSection = (section) => {
    setOpenQuestionSection(openQuestionSection === section ? null : section);
    setExpanded(null);
  };

  const handleChange = (panel) => {
    setExpanded(expanded === panel ? null : panel);
  };
  const filteredList = QuestionsList.filter((s) => hasService(s.service));
  return (
    <Suspense fallback={<CircularProgress />}>
      <Container
        id="faq"
        maxWidth="md"
        sx={{
          pt: 4,
          pb: 2,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          component="h2"
          variant="h4"
          color="text.secondary"
          sx={{
            width: '100%',
            textAlign: 'center',
          }}
        >
          {t('title')}
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          alignItems="left"
          justifyContent="left"
          sx={{ padding: 2 }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <LocalPhoneIcon
                sx={{
                  fontSize: '40px',
                  p: '5px',
                  mr: 1,
                }}
              />
              <Typography variant="subtitle1" sx={{ p: '5px' }}>
                +45 30 64 16 27
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <EmailRoundedIcon
                sx={{
                  // color: 'hsl(63, 100%, 40%)',
                  // border: '1px solid hsl(63, 100%, 40%)',
                  // borderRadius: '50%',
                  fontSize: '40px',
                  p: '5px',
                  mr: 1,
                }}
              />
              <Typography variant="subtitle1" sx={{ p: '5px' }}>
                <a href="mailto:support@remoni.com">support@remoni.com</a>
              </Typography>
            </Box>
          </Box>
        </Stack>
        {filteredList.length > 0 ? (
          <Stack width={'100%'} gap={2}>
            {filteredList.map((service) => (
              <Card
                variant="outlined"
                key={service.service}
                sx={{ width: '100%' }}
              >
                <CardContent>
                  <Suspense fallback={<Skeleton />}>
                    <FaqServiceSectionWrapper
                      key={service.service}
                      title={service.title}
                    >
                      {service.sections.map((section, index) => {
                        const sectionId = `section_${service.service}_${index + 1}`;
                        return (
                          <Suspense key={section.title} fallback={<Skeleton />}>
                            <FaqQuestionSectionWrapper
                              key={section.title}
                              title={section.title}
                              id={sectionId}
                              toggleSection={toggleSection}
                              expanded={openQuestionSection === sectionId}
                            >
                              <Suspense fallback={<Skeleton />}>
                                {section.questions.map((q, idx) => {
                                  const id = `question_${index + 1}_${idx + 1}`;
                                  return (
                                    <FaqQuestion
                                      key={id}
                                      id={id}
                                      expanded={expanded === id}
                                      handleChange={handleChange}
                                      title={q.title}
                                      details={q.answer}
                                    />
                                  );
                                })}
                              </Suspense>
                            </FaqQuestionSectionWrapper>
                          </Suspense>
                        );
                      })}
                    </FaqServiceSectionWrapper>
                  </Suspense>
                </CardContent>
              </Card>
            ))}
          </Stack>
        ) : (
          <Alert severity="info">
            <Typography>{t('intro')}</Typography>
          </Alert>
        )}
      </Container>
    </Suspense>
  );
};

export default SupportPage;
